import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const ConnectMe = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_ifohwkj', 'template_lqppuoq', form.current, 'gDLu4Le8gJCA7hbUX')
            .then((result) => {
                console.log(result.text);
                form.current.reset();

            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <div className='bg-slate-800 text-white h-screen '>
            <h3 className='text-4xl font-bold pt-3'>Contact Me</h3>
               <div className='grid lg:grid-cols-2 items-center'>
                <div>
                <p class="font-bold">Bijon Talukder</p>
               <p class="font-thin">Chittagong , Bangladesh</p>
               <a href="mailto: bijontalukder1247@gmail.com" class="border-b-2 mt-3 inline-block border-gray-500">bijontalukder1247@gmail.com</a>
                </div>
              
                
               
            <div >
            <form     ref={form} onSubmit={sendEmail}>
            <div className='flex bg-gray-700 rounded-lg p-4 flex-col form-control  my-6 mx-auto max-w-lg'>
            <div>
                <label className='label'>
                <span className="label-text text-white">Name</span>
                </label>
                <input type="text" name="user_name" placeholder='your name' className="input input-bordered input-primary w-full max-w-xs"/>
            </div>
            <div>
            <label className='label'>
                <span className="label-text text-white">Email</span>
                </label>
                <input type="email" name="user_email" placeholder='type your email' className="input input-bordered input-primary w-full max-w-xs" />

            </div>
            <div>
            <label className='label'>
                <span className="label-text text-white">Message</span>
                </label>
                <textarea name="message" placeholder='message' className="input input-bordered input-primary w-full h-44 max-w-xs text-black"/>

            </div>
            <div>
                <button type='submit' className="btn btn-success my-3"> Submit </button>

                {/* <input type="submit" className='className="btn btn-success"' value="Send" /> */}
            </div>
            </div>


        </form>

            </div>
            </div>
        </div>
       
    );
};

export default ConnectMe;